import { dateFormat } from '../../utils/date'
import { Data } from './types'

type TypeFromArray<T> = T extends Array<infer U> ? U : never

export const getOverrideableMonth = (week: TypeFromArray<Data['weeks']>) => (
  week.overrideMonth || dateFormat(Array.isArray(week.date) ? week.date[0] : week.date, 'yyyy-MM')
)
